import { render } from "./info-block.vue?vue&type=template&id=3be911c2&lang=pug"
import script from "./info-block.vue?vue&type=script&lang=js"
export * from "./info-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__